module.exports = __webpack_public_path__ + "static/media/segro-park-coventry-gateway.2c3adc3b.jpg";